import React, { useState, useEffect } from 'react';
import ReactHtmlParser from 'html-react-parser';
import Element from '../../../../../components/element';
import { ReactComponent as IconRemove } from '../../../../../assets/icons/IconRemove.svg';
import useStyles from './style'
import { isNullOrUndefined } from '../../../../../utils'
import medications from '../../../../../jsons/medicationList.json';

const FilterList = props => {
  const {
    medicationList,
    columns,
    question,
    rawAnswers,
    className,
    storeAnswer,
    questionId,
    selectedList,
    setSelectedMedications,
    text
  } = props;
  const classes = useStyles()

  const [rawSelectedList, setRawSelectedList] = useState(medicationList);
  const [originalList, setOriginalList] = useState(medicationList);

  const initializeData = ()=>{
    let updatedList = medicationList && medicationList.length > 0 ? medicationList : medications;
  
    const selectedAnswers = rawAnswers?.selected || [];
  
    // Merge selection status into the medication list
    updatedList = updatedList.map(item => {
      const match = selectedAnswers.find(sel => sel.value === item.value);
      return match ? { ...item, checked: true } : { ...item, checked: false };
    });
  
    setRawSelectedList(updatedList);
    setOriginalList(updatedList);
  }

  useEffect(() => {
    initializeData()
  }, []); // ✅ reacts to updates AND runs on mount
  

  useEffect(() => {
    initializeData()
  }, [medicationList]); 

  const updateList = (event, questionId) => {
    let medList = [...rawSelectedList]
    const value = event.currentTarget.value
    const isChecked = event.currentTarget.checked
    const initialList = selectedList && selectedList['selected'] || []
    let selectedListTemp = initialList.length > 0 ? [...initialList] : []
    medList.map(item => {
      if (item.value === value) {
        item.checked = isChecked
        if (isChecked === true) {
          selectedListTemp.push(item)
          setSelectedMedications(selectedListTemp)
        } else {
          const removedCheckedList = initialList.filter(item => item.value !== value)
          selectedListTemp = removedCheckedList
          setSelectedMedications(removedCheckedList)
        }
      }
      return item
    })
    const answered = selectedListTemp.length > 0 ? true : false
    storeAnswer(questionId, { selected: selectedListTemp }, answered, undefined, undefined, answered)
  }

  const filterOnChange = (event) => {
    const searchValue = event?.currentTarget?.value || ''

    if (searchValue.length > 0) {
      const result = medicationList.filter(item => {
        return item.value.toLowerCase().indexOf(searchValue) === 0
      })
      setRawSelectedList(result)
    } else {
      setRawSelectedList(originalList)
    }
  }
  return (
    <div className={className}>
      <Element type="p" fontFamily="GTAM" fontSize="14px">
        {ReactHtmlParser(question)}
      </Element>
      <Element
        {...(text && text.horizontal && { display: 'flex', alignItems: 'end' })}
        {...(columns && { display: 'flex', alignItems: 'normal' })}

      >
        {/* Full list box */}
        <Element type='div' className={classes.filterContainer}>
          <Element type='div' className={classes.firstBox} >
            <div className={classes.searchBoxContainer}>
              <input type='text' className={classes.searchBox} placeholder="Search drugs" onChange={(e) => filterOnChange(e)} />
            </div>
            <ul className={classes.listMainClass}>
              {rawSelectedList?.length > 0 ? rawSelectedList?.map(option => {
                return (<Element type="li">
                  <input type="checkbox" value={option.value} id={`cb_${option.value}`} checked={option.checked} onChange={(event) => updateList(event, questionId)} />
                  <label className={classes.listItemLabel} htmlFor={`cb_${option.value}`}>{option.value}</label>
                </Element>)
              }) : <div className={classes.matchNotFound}>No Matches Found</div>
              }
            </ul>
          </Element>
        </Element>
        {/* Selected list box */}
        <Element type='div' className={classes.filterContainer}>
          <Element type="ul" className={`${classes.listMainClass} ${classes.selectedListClass}`}>
            {selectedList && selectedList?.selected?.length > 0 && selectedList['selected'].map((option) => {
              return (<Element type="li">
                <label className={classes.removeIconContainer} onClick={(event) => updateList(event, questionId)}>
                  <input type="checkbox" className={classes.removeIcon} value={option.value} checked={option.checked} onChange={(event) => updateList(event, questionId)} />
                  <IconRemove className={classes.svgIcon} />
                  <Element type="span" className={classes.removeIconLabel}>{option.value}</Element>
                </label>
              </Element>)
            })}
          </Element>
        </Element>
      </Element>
    </div >
  );
};

export default FilterList;
